import { SVGProps } from 'react'

export const MarkIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="34rem"
      height="25rem"
      viewBox="0 0 34 25"
      fill="none"
      {...props}
    >
      <path
        d="M6 13.5L12.09 19.59C12.87 20.37 14.13 20.37 14.91 19.59L26.5 8"
        stroke="black"
        strokeWidth="8"
        strokeLinecap="square"
      />
      <path
        d="M6 12.5L12.09 18.59C12.87 19.37 14.13 19.37 14.91 18.59L32 1.5"
        stroke="url(#paint0_linear_3247_9815)"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3247_9815"
          x1="8.5"
          y1="20"
          x2="32"
          y2="-4"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.36" stopColor="#E7E7E7" />
          <stop offset="1" stopColor="#4F4F4F" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
